import APIKit from "../APIKit";

function getReferralEarnings(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = window.localStorage.getItem("auth_token");
      if (token) {
        payload.append("auth_token", token);
      }
    } catch (e) {

    }

    // Determine content type based on payload type
    let contentType = "multipart/form-data";
    if (payload instanceof URLSearchParams) {
      contentType = "application/x-www-form-urlencoded";
    }

    APIKit.post("/get_user_referral_earnings", payload, {
      headers: {
        "content-type": contentType,
      }
    })
      .then(async (response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error("err===========" + e);
          reject(e);
        }
      })
      .catch((err) => {
        console.error("err===========" + err);
        reject(err);
      });
  });
}

function addReferralAmountToWallet(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = window.localStorage.getItem("auth_token");
      if (token) {
        payload.append("auth_token", token);
      }
    } catch (e) {

    }

    // Determine content type based on payload type
    let contentType = "multipart/form-data";
    if (payload instanceof URLSearchParams) {
      contentType = "application/x-www-form-urlencoded";
    }

    APIKit.post("/add_referral_amount_to_wallet", payload, {
      headers: {
        "content-type": contentType,
      }
    })
      .then(async (response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error("err===========" + e);
          reject(e);
        }
      })
      .catch((err) => {
        console.error("err===========" + err);
        reject(err);
      });
  });
}

export const referralService = {
  getReferralEarnings,
  addReferralAmountToWallet,
};
